import React, { useState, useContext, useEffect } from "react";
import Header from "../header";
import { Toast } from "antd-mobile";
import PsContext from "../../context";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { Button, Card, Col, Row } from "react-bootstrap";
import { List } from "antd-mobile";

import $ from "jquery";
import { FloatButton, Avatar, Spin, Space } from "antd";
import {
  Form,
  Input,
  Select,
  InputNumber,
  Radio,
  Checkbox,
  DatePicker,
} from "antd";
import { momentDate, getFileLiveUrl } from "../../utils";

export default function ViewFeedbackQuestions(props) {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [listQuestions, setListQuestions] = useState([]);
  const [listOptions, setListOptions] = useState([]);
  const [feedbackForm] = Form.useForm();
  const [saveLoader, setSaveLoader] = useState(false);
  useEffect(() => {
    loadQuestionsAndOptions(props.feedback.id);
  }, []);
  const loadQuestionsAndOptions = (feedback_id) => {
    setLoader(true);
    setListQuestions([]);
    var form = new FormData();
    form.append("feedback_id", feedback_id);
    axios
      .post(
        ServiceUrl.STUDENTS.LIST_FEEDBACK_QUESTIONS +
          "?" +
          "student_uuid=" +
          context.user.uuid,
        form
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setListQuestions(res["data"].data);
          setListOptions(res["data"].dataOptions);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };
  const getQuestionInput = (questionItem) => {
    if (questionItem.answer_type == "objective") {
      var options = [];
      var optionData = listOptions.filter(
        (item) => item.question_id === questionItem.id
      );
      optionData.forEach((item) => {
        options.push(
          <Radio.Button value={item.id}>{item.option_text}</Radio.Button>
        );
      });
      return (
        <Radio.Group optionType="default">
          <Space direction="vertical">{options}</Space>
        </Radio.Group>
      );
    } else {
      return <Input.TextArea rows={3} />;
    }
  };

  const onFinishFeedback = (values) => {
    setLoader(true);
    var processedValues = {};
    Object.entries(values.answers).forEach(([key, value]) => {
      if (value) {
        processedValues[key] = value;
      }
    });

    var answers = [];
    listQuestions.forEach((item, index) => {
      if (item.answer_type == "objective") {
        answers.push({
          question_id: item.id,
          option_id: values.answers[index],
          answer_text: null,
        });
      } else {
        answers.push({
          question_id: item.id,
          option_id: null,
          answer_text: values.answers[index],
        });
      }
    });
    const form = new FormData();
    form.append("target_audience_id", context.user.uuid);
    form.append("feedback_id", props.feedback.id);
    form.append("answer_json", JSON.stringify(answers));
    axios.post(ServiceUrl.STUDENTS.SAVE_STUDENT_FEEDBACK, form).then((res) => {
      if (res["data"].status == "1") {
        Toast.show({ content: "Answer Submitted" });
        setLoader(false);
        props.onSuccess();
      } else {
        setLoader(false);
      }
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    axios
      .post(
        ServiceUrl.STUDENTS.SAVE_STUDENT_FEEDBACK,
        $("#frm_add").serialize()
      )
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });
          setLoader(false);
          document.getElementById("frm_add").reset();
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      });
  };

  return (
    <>
      <Spin spinning={loader}>
        <div className="container-sm">
          <Card>
            <Card.Body>
              <Row>
                <Col md={12}>
                  {props.feedback.feedback_title}
                  <hr />
                </Col>
              </Row>
              <Form
                name="basic"
                form={feedbackForm}
                labelAlign="left"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                onFinish={onFinishFeedback}
                autoComplete="off"
              >
                <Row>
                  <Col md={12}>
                    {listQuestions.map((item, index) => {
                      return (
                        <>
                          <Form.Item
                            label={index + 1 + ") " + item.question_text}
                            name={["answers", index]}
                            rules={[
                              { required: true, message: "Select answer" },
                            ]}
                          >
                            {getQuestionInput(item)}
                          </Form.Item>
                        </>
                      );
                    })}
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="text-end">
                    <Button
                      type="submit"
                      variant="success"
                      className="btn btn-block "
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Spin>
    </>
  );
}
